import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {DartDealService} from "../../deal-list/dart-deals.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {DealProjectSummaryModel} from "../../deal-list/deal-list.gql-model";

@Component({
  templateUrl: "./daas-project-summary.template.pug",
  providers: [DartDealService],
})
export class DaasProjectSummaryComponent extends WorkflowStep {
  project: DealProjectSummaryModel = new DealProjectSummaryModel({});
  targetSystem: string = "legacy";
  error: Error;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private dartDealService: DartDealService,
  ) {
    super();
  }

  @handleErrors()
  async loadData() {
    const {project} = await this.dartDealService.getFullList(this.workflowTargetInfo.projectId);

    this.project = project;
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
  }

  @handleErrors()
  async ready() {
    this.loading = true;
    await this.loadData();
    this.loading = false;
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    this.error = undefined;

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }
}
